// extracted by mini-css-extract-plugin
export default {"featured":"Featured_featured__auSQM","featuredItem":"Featured_featuredItem__hMISm","featuredImg":"Featured_featuredImg__Ib8Wy","featuredTitles":"Featured_featuredTitles__gSo+5"};